/**
 * Tree & File System Tokens
 */

import { bg, text, accent, corners, space, border } from "../semantic";

export const treeItem = {
  bg: bg.base,
  bgHover: bg.surface,
  bgPressed: bg.surfaceHover,
  bgFocused: accent.secondaryMuted,
  height: "44px",
  paddingX: space.insetLg,
  gap: space.insetMd,
  border: `0.5px solid ${border.default}`,
  borderFocused: `3px solid ${accent.secondary}`,
  icon: { size: "32px", radius: corners.icon, bgFolder: border.default, bgFile: bg.surface },
  badge: { fontSize: "11px", padding: `${space.insetXs} ${space.insetSm}`, radius: corners.button, bg: accent.secondary, text: text.onAccent },
} as const;

export const deleteZone = {
  width: "72px",
  bg: accent.danger,
  iconColor: text.onAccent,
  iconSize: "20px",
} as const;
